import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Panel } from "../components/common/Panel";
import { CopyBtn, Row } from "../components/common/Detail";
import { Loading, NotFound } from "./BlockDetail";
import { getTx } from "../lib/api";
import { timeAgo, fmtNum, fmtEth, CHAIN } from "../lib/format";

export default function TxDetail() {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [tx, setTx] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setTx(null); setErr(false);
    getTx(hash).then(setTx).catch(() => setErr(true));
  }, [hash]);

  if (err) return <NotFound label="Transaction" navigate={navigate} />;
  if (!tx) return <Loading />;

  const success = tx.status === 1 || tx.status === "0x1" || tx.status === true;

  return (
    <div className="fade-in" data-testid="tx-detail-page">
      <div className="mb-4 flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="nav-link" data-testid="back-btn"><i className="fa-solid fa-arrow-left" /></button>
        <div>
          <span className="eyebrow" style={{ color: "var(--amber)" }}>Transaction</span>
          <h1 className="font-display text-[20px] font-extrabold mt-1 mono break-all">{tx.hash}</h1>
        </div>
      </div>

      <Panel title="Transaction Details">
        <Row label="Status">
          {tx.status === null || tx.status === undefined
            ? <span className="pill pill-muted">Pending</span>
            : success
              ? <span className="pill pill-green"><i className="fa-solid fa-check" /> Success</span>
              : <span className="pill pill-red"><i className="fa-solid fa-xmark" /> Failed</span>}
        </Row>
        <Row label="Tx Hash" mono>{tx.hash}<CopyBtn text={tx.hash} testId="copy-tx-hash" /></Row>
        <Row label="Block"><Link to={`/block/${tx.blockNumber}`} className="link-amber mono">#{fmtNum(tx.blockNumber)}</Link></Row>
        {tx.timestamp && <Row label="Timestamp">{timeAgo(tx.timestamp)} · {new Date(tx.timestamp * 1000).toUTCString()}</Row>}
        <Row label="From" mono><Link to={`/address/${tx.from}`} className="link-amber">{tx.from}</Link></Row>
        <Row label="To" mono>{tx.to ? <Link to={`/address/${tx.to}`} className="link-amber">{tx.to}</Link> : (tx.contractAddress ? <>Contract Created: <Link to={`/address/${tx.contractAddress}`} className="link-amber">{tx.contractAddress}</Link></> : "—")}</Row>
        <Row label="Value">{fmtEth(tx.valueEth, 6)} {CHAIN.symbol}</Row>
        <Row label="Gas Used">{fmtNum(tx.gasUsed || tx.gas)}</Row>
        <Row label="Gas Price">{fmtNum(tx.gasPrice)} wei</Row>
        <Row label="Nonce">{fmtNum(tx.nonce)}</Row>
        {tx.logs !== undefined && <Row label="Event Logs">{tx.logs} logs emitted</Row>}
        <Row label="Input Data" mono><span style={{ color: "var(--muted)" }}>{tx.input}</span></Row>
      </Panel>
    </div>
  );
}
